module.exports = __webpack_public_path__ + "img/seller_certificates_2.34180f78.svg";